import Link from "next/link";
import cn from "classnames";
import {
  AscAvatar,
  AscEmptyList,
  AscImage,
  AscTag,
} from "@ascendnow/ascend-components";
import { IFetchPostListItem } from "@ascendnow/shared";
import { formatTime, getPostTypeColor } from "./helper";
import styles from "./AscPostCard.module.scss";

export const AscPostAuthorDate = ({
  authorImageSrc,
  authorName,
  date,
}: {
  authorImageSrc: string;
  authorName: string;
  date: string;
}) => (
  <div className={styles.postCardFooter}>
    <AscAvatar size="small" src={authorImageSrc} />
    <span className={styles.postCardAuthor}>By {authorName}</span>
    <span className={styles.postCardDate}>{formatTime(date)}</span>
  </div>
);

export const AscPostCard = ({ post }: { post: IFetchPostListItem }) => (
  <Link href={`/posts/${post.id}`} className={styles.postCard}>
    <div className={styles.postCardImage}>
      <AscImage src={post.postImage.location} alt={post.title} />
    </div>
    <div className={styles.postCardDetails}>
      <div className={styles.postCardHeader}>
        <h2 className={styles.postCardTitle}>{post.title}</h2>
        <AscTag
          label={post?.postType}
          type={getPostTypeColor(post?.postType)}
        />
      </div>
      <span
        className={styles.postCardSubtitle}
        dangerouslySetInnerHTML={{ __html: post.text }}
      />
      <AscPostAuthorDate
        authorImageSrc={post?.author?.authorImage?.location}
        authorName={post?.author?.firstName + " " + post?.author?.lastName}
        date={post?.createdAt}
      />
    </div>
  </Link>
);

export const AscPostCardList = ({
  isFetching,
  posts,
  isSinglePage,
}: {
  isFetching?: boolean;
  posts: IFetchPostListItem[];
  isSinglePage?: boolean;
}) => {
  if (!isSinglePage && posts.length < 1) {
    return <AscEmptyList title="Not found" fillHeight />;
  }

  return (
    <div className={cn(styles.postCardList, isSinglePage && styles.singlePage)}>
      {posts.map((post) => (
        <AscPostCard key={post.id} post={post} />
      ))}
      {/* {page && totalPages && page < totalPages && (
                <div
                    className={styles.loadMoreAnimation}
                    onClick={() => {
                        router.query.page = String(page + 1);
                        router.push(router);
                    }}
                >
                    {!isFetching && <span className={styles.loadMoreText}>Load more</span>}
                    <div className={cn(styles.loadMore, isFetching && styles['loadMore--active'])} />
                </div>
            )} */}
    </div>
  );
};
